/**
 * Validate email format
 * @param {string} email - Email address
 * @returns {boolean}
 */
export const isValidEmail = (email) => {
  const re = /^[^\s@]+@([^\s@]+\.)+[^\s@]+$/;
  return re.test(email);
};

/**
 * Validate Kenyan phone number (2547XXXXXXXX or 07XXXXXXXX)
 * @param {string} phone - Phone number
 * @returns {boolean}
 */
export const isValidPhone = (phone) => {
  const re = /^(2547|07)[0-9]{8}$/;
  return re.test(phone);
};

/**
 * Validate Kenyan ID number (8 digits)
 * @param {string} idNumber - ID number
 * @returns {boolean}
 */
export const isValidIdNumber = (idNumber) => {
  const re = /^[0-9]{8}$/;
  return re.test(idNumber);
};

/**
 * Validate password strength (min length 6)
 * @param {string} password - Password
 * @returns {boolean}
 */
export const isStrongPassword = (password) => {
  return password && password.length >= 6;
};

/**
 * Validate that a value is a positive number
 * @param {number} value - Value to check
 * @returns {boolean}
 */
export const isPositiveNumber = (value) => {
  return !isNaN(value) && value > 0;
};

/**
 * Validate required field (non-empty)
 * @param {any} value - Value to check
 * @returns {boolean}
 */
export const isRequired = (value) => {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string') return value.trim().length > 0;
  return true;
};

/**
 * Validate date range (start <= end)
 * @param {Date} start - Start date
 * @param {Date} end - End date
 * @returns {boolean}
 */
export const isValidDateRange = (start, end) => {
  if (!start || !end) return true;
  return new Date(start) <= new Date(end);
};

/**
 * Validate that allocation sums to 100
 * @param {Array} beneficiaries - Array of objects with allocation property
 * @returns {boolean}
 */
export const isValidBeneficiaryAllocation = (beneficiaries) => {
  if (!Array.isArray(beneficiaries)) return false;
  let total = 0;
  for (const b of beneficiaries) {
    const allocation = parseFloat(b.allocation);
    if (isNaN(allocation) || allocation < 0 || allocation > 100) return false;
    total += allocation;
  }
  return Math.abs(total - 100) < 0.01;
};